import React from "react";
import Text from "../../atoms/Text/Text";
// import Timer from '../../molecules/Timer/Timer';
import { useTranslation } from "react-i18next";
import Button from "../../atoms/Button/Button";
import "./subheader.scss";

const Subheader = () => {
  const { t } = useTranslation();

  const handleButtonClick = () => {
    // Scroll to the tabs container instead of the list
    const tabsElement = document.querySelector('.treatments__tabs');
    if (tabsElement) {
      const yOffset = -60; // Increased offset for more space above tabs
      const y = tabsElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="subheader" role="region" aria-labelledby="subheader-title">
      <div className="subheader-content">
        <Text variant="h3" id="subheader-title">
          {t("subheader.welcome")}
        </Text>
        <Text variant="p">{t("subheader.reservePrompt")}</Text>
        <Button variant="primary" onClick={handleButtonClick}>
          {t("subheader.reserveButton")}
        </Button>
      </div>
    </div>
  );
};

export default Subheader;
